import { useEffect } from "react";
import { toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
import { removeDigitos } from "../../../utils/masks";
import { IAutenticacaoForm, IDecodedToken } from "../../../types/autenticacao";
import { RolesEnum } from "../../../enums/roles";
import { Cliente } from "../../../services/Cliente";
import { useContextSite } from "../../../context/Context";
import { Autenticacao } from "../../../services/Autenticacao";
import { useSessionStorage } from "../../../hooks/useSessionStorage";
import { useNavigate, useParams } from "react-router-dom";
import { Agendamento } from "../../../services/Agendamento";
import { Colaborador } from "../../../services/Colaborador";
import { Usuario } from "../../../services/Usuario";

export const useLogin = () => {
  const { setIsLoad, setPerfis } = useContextSite();
  const [token, setToken] = useSessionStorage("@token");
  const params = useParams();
  const navigate = useNavigate();
  const [usuario, setUsuario] = useSessionStorage("@usuarioMapa");

  async function onSubmitForm(data: IAutenticacaoForm) {
    setIsLoad(true);

    const PAYLOAD: IAutenticacaoForm = {
      cpfCNPJ: removeDigitos(data.cpfCNPJ),
      senha: data.senha,
    };

    await Autenticacao.post(PAYLOAD)
      .then(({ data }) => {
        setToken(data.token);
        return data.token;
      })
      .then(async (token) => {
        const decoded = jwtDecode<IDecodedToken>(token);

        try {
          const is_cliente = decoded?.perfis?.some(
            (perfil) => perfil === RolesEnum.ROLE_CLIENTE
          );

          if (!is_cliente) {
            await Usuario.getRecursosByUuid({uuid: decoded.uuid}).then(({data}) => {
              toast.success("Login efetuado com sucesso");
              setUsuario({
                uuidUsuario: decoded.uuid,
                usuarioCpfCnpj: decoded.sub,
                nome: decoded.nome,
                roles: decoded.perfis,
                recursos: data,
              });
              navigate("/meus-agendamentos");
              return;
            })
            .catch(
              ({
                response: {
                  data: { mensagem },
                },
              }) => {
                toast.error(mensagem);
                localStorage.removeItem("@token");
              }
            );
          } else {
            await Cliente.getByUsuario({ uuidUsuario: decoded.uuid })
              .then(({ data }) => {
                setUsuario({
                  uuidUsuario: decoded.uuid,
                  uuidCliente: data.uuid,
                  nome: decoded.nome,
                  roles: decoded.perfis,
                  tipo: data.tipo,
                });

                toast.success("Login efetuado com sucesso");
                navigate("/agendamento/inicio");
              })
              .catch(
                ({
                  response: {
                    data: { mensagem },
                  },
                }) => {
                  toast.error(mensagem);
                  localStorage.removeItem("@token");
                }
              );
          }
        } catch (error) {
          toast.error(error);
        }
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => {
          toast.error(mensagem);
        }
      )
      .finally(() => {
        setIsLoad(false);
      });
  }

  useEffect(() => {
    if (token) {
      localStorage.clear();
    }
  }, []);

  return {
    onSubmitForm,
  };
};
